








import { defineComponent } from 'vue';
import Icon from '../Icon.vue';
import { iconClassEnum } from '../../enums/iconClassEnum';
import { AULA_URLS } from '../../constants/urls';

export default defineComponent({
  components: { Icon },
  setup() {
    return {
      iconClassEnum,
      AULA_URLS,
    };
  },
});
